// extracted by mini-css-extract-plugin
module.exports = {"content":"create-wishlist-dialog_content__GBtN1","wrapper":"create-wishlist-dialog_wrapper__m_fZE"};